import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Image, Path, Group, Text, geometry } from '@progress/kendo-drawing';
import { generateDataChartForIncomeProtection } from '@app/features/my-financial/my-financial';
import { formatStringToCurrency } from '@app/features/coverage/coverage';
const { Rect, Point, Size, transform } = geometry;

@Component({
  selector: 'app-range-area-chart-income-protection',
  templateUrl: './range-area-chart-income-protection.component.html'
})
export class RangeAreaChartIncomeProtectionComponent
  implements OnInit, AfterViewInit {
  @Input() data;
  _data: any;
  formatStringToCurrency: any;
  valueAxisLabels: any;
  isMobile: boolean;
  categories: [''];

  ngOnInit() {
    this._data = generateDataChartForIncomeProtection(
      this.data.form.value,
      this.data.userAge
    );
    this.formatStringToCurrency = formatStringToCurrency;
    this.isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
      navigator.userAgent.toLowerCase()
    );
    this.valueAxisLabels = {
      padding: 3,
      font: this.isMobile
        ? 'normal 10px Arial, sans-serif'
        : 'normal 14px Arial, sans-serif',
      color: '#656565'
    };
  }

  ngAfterViewInit() {
    this.data.form.valueChanges.subscribe(formValue => {
      this._data = generateDataChartForIncomeProtection(
        formValue,
        this.data.userAge
      );
    });
  }

  onRender(sender) {
    // TODO: fix bug the chart could not be in 100% width.
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/range-area-chart-income-protection/range-area-chart-income-protection.component.ts